import { Button, styled } from "@mui/material";


export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 4px 19px rgba(0, 0, 0, 0.25)",
  marginTop: theme.spacing(4),
}));